import { gql } from "@apollo/client";
import Fragments from "./fragments";

export const QUOTE_QUERY = gql`
  query quote($quoteId: Int!) {
    quote(quoteId: $quoteId) {
      ...quote
    }
  }
  ${Fragments.quote}
`;

export const QUOTE_HEADER_QUERY = gql`
  query quote($quoteId: Int!, $loadProducts: Boolean!) {
    quote(quoteId: $quoteId) {
      ...quote
      quoteAssets {
        quoteAssetId
        assetId
        qtty
        assetName
        brandId
        brandName
        kindOfObjectName
        assetNetPrice
        assetNetPriceWithVAT
        additionalCosts
        additionalCostsWithVAT
        conditionTypeId
        conditionTypeName
        manufacturingYear
        operatingHours
        assetDescription
        supplierId
        supplierName
      }
      quoteProducts @skip(if: $loadProducts) {
        ...quoteProduct
      }
    }
  }
  ${Fragments.quote}
  ${Fragments.quoteProduct}
`;

export const QUOTE_WITH_ASSETS_QUERY = gql`
  query quote($quoteId: Int!) {
    quote(quoteId: $quoteId) {
      ...quote
      quoteAssets {
        quoteAssetId
        assetId
        qtty
        assetName
        brandId
        brandName
        kindOfObjectName
        assetNetPrice
        assetNetPriceWithVAT
        additionalCosts
        additionalCostsWithVAT
        conditionTypeId
        conditionTypeName
        manufacturingYear
        operatingHours
        assetDescription
        supplierId
        supplierName
      }
    }
  }
  ${Fragments.quote}
`;

export const QUOTE_WITH_PRODUCTS_QUERY = gql`
  query quote($quoteId: Int!) {
    quote(quoteId: $quoteId) {
      ...quote
      quoteProducts {
        ...quoteProduct
      }
    }
  }
  ${Fragments.quote}
  ${Fragments.quoteProduct}
`;

export const GET_PRODUCT_SCHEDULE_TYPES_AND_PERIODICITIES = gql`
  query productScheduleTypes($productId: Int!, $paymentFrequency: String!) {
    productScheduleTypes(productId: $productId) {
      id
      name
      caption
      isConfigurable
      templates {
        scheduleTypeCellParamTemplateId
        templateName
      }
    }
    productPeriodicities(paymentFrequency: $paymentFrequency) {
      id
      name
    }
  }
`;

export const QUOTE_WITH_PRODUCT_HISTORY_QUERY = gql`
  query quote($quoteId: Int!) {
    quote(quoteId: $quoteId) {
      quoteId
      quoteProductHistories {
        quoteProductId
        quoteId
        productName
        productTypeId
        productTypeName
        duration
        downPaymentAmount
        downPaymentAmountWithVAT
        residualValueVisible
        residualValueAmount
        residualValueAmountWithVAT
        firstName
        lastName
        modifiedTimestamp
        downloadTimestamp
        mailTimestamp
        ratingBasedInterestPercent
      }
    }
  }
`;

export const QUOTE_WITH_CONTACT_PERSON_QUERY = gql`
  query quote($quoteId: Int!) {
    quote(quoteId: $quoteId) {
      quoteId
      offerNotes
      contactInfoId
      partnerTypeId
      contactPersons {
        webContactInfoId
        firstName
        lastName
        fullName
        phone
        email
        alternativeEMail
      }
    }
  }
`;

export const GET_LEASING_CONTRACT_AND_DEALER_DOCUMENTS_LIST = gql`
  query quote($quoteId: Int!) {
    quote(quoteId: $quoteId) {
      quoteId
      quoteStatusId
      transactionId
      contactInfoId
      contactPersons {
        webContactInfoId
        alternativeEMail
      }
      leasingContracts {
        documentId
        siteId
        clientId
        documentDate
        documentStateCode
        documentStateName
        documentNumber
        allowToggle
        allowUpload
        allowDownload
        allowDownloadTemplate
        requiredDocuments {
          quoteId
          id
          requiredDocTypeId
          requiredDocFileName
          requiredDocName
          requiredDocContentType
          targetAreaCode
          caption
          isVisible
          isMandatory
          documentTemplateId
          templateContentType
          guarantorId
          guarantorName
          files {
            sharePointUID
            fileName
          }
        }
      }
      dealerDocuments {
        dmsDocumentId
        dmsSiteId
        dmsContentType
        documentWasUploaded
        file {
          fileName
          sharePointUID
        }
      }
    }
  }
`;

export const GET_ZOOT_DOCUMENT_DECISION_INFO_QUERY = gql`
  query quote($quoteId: Int!) {
    quote(quoteId: $quoteId) {
      quoteId
      folderId
      zootDocDecisionFinished
      zootDocDecisionColor
      zootDocDecisionReasons
    }
  }
`;
